import React, { lazy, Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import Layout from "../navigation/Layout";

const App = lazy(() => import("../App"));

export const customRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route
        index
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <App data="amplify" />
          </Suspense>
        }
      />
      <Route
        path="cost"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <App data="cost" />
          </Suspense>
        }
      />
      <Route
        path="webhook"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <App data="webhook" />
          </Suspense>
        }
      />
    </Route>
  )
);
